/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-08-16 22:41:36 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-22 02:54:20
 */

// import _ from 'lodash';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { Propose } from '../models/propose.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { TransService } from './trans.service';
// import { PageInfo } from '../common/page-info.interface';

@Injectable()
export class ProposeService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/proposes`;

  private _updatedPorpose: BehaviorSubject<Propose> = new BehaviorSubject(null);
  private _deletedPorposeId: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  createPropose(data) {
    return this.http.post(`${this.url}`, data);
  }

  getProposes(page: number, requester: string, celeb: string, status: string, filter?: string) {
    return this.http.get(`${this.url}?page=${page}&status=${status || ''}&requester=${requester || ''}&celeb=${celeb || ''}&filter=${filter || ''}&lang=${this.transService.lang}`);
  }

  getAdminProposes(page: number, requester: string, celeb: string, status: string, filter?: string) {
    return this.http.get(`${this.url}/admin?page=${page}&status=${status || ''}&requester=${requester || ''}&celeb=${celeb || ''}&filter=${filter || ''}&lang=${this.transService.lang}`);
  }

  getPropose(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updatePropose(id: string, data) {
    return this.http.put(`${this.url}/${id}?lang=${this.transService.lang}`, data);
  }

  deletePropose(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  changeStatus(id: string, status: string, data?) {
    return this.http.put(`${this.url}/${id}/status?lang=${this.transService.lang}`, {
      status: status,
      data: data
    });
  }


  setMessage(id: string, messageId: string) {
    return this.http.put(`${this.url}/${id}/set-message?lang=${this.transService.lang}`, {
      message: messageId
    });
  }


  updateProposeRecieved(propose: Propose) {
    this._updatedPorpose.next(propose);
  }

  deleteProposeIdRecieved(id: string) {
    this._deletedPorposeId.next(id);
  }

  get updatedPropose$() {
    return this._updatedPorpose.asObservable();
  }

  get deletedProposeId$() {
    return this._deletedPorposeId.asObservable();
  }

  // processDeletedProposeId(id: string, proposes: Propose[], pageInfo: PageInfo) {
  //   if (!id)
  //     return pageInfo;

  //   const removed = _.remove(proposes, propose => propose._id === id);
  //   if (removed && removed.length > 0)
  //     pageInfo.total--;
  //   return pageInfo;
  // }

  // processUpdatedPropose(propose: Propose, proposes: Propose[], pageInfo: PageInfo, status: string) { 
  //   if (!propose)
  //     return pageInfo;
    
  //   const findIndex = _.findIndex(proposes, p => p._id === propose._id);
  //   if (findIndex >= 0) {
  //     if (this.isAvaliableStatus(propose, status)) {
  //       proposes[findIndex] = propose;
  //     } else {
  //       pageInfo = this.processDeletedProposeId(propose._id, proposes, pageInfo);
  //     }
  //   } else if(this.isAvaliableStatus(propose, status)) {
  //     proposes.unshift(propose);
  //     pageInfo.total++
  //   }
  //   return pageInfo;
  // }

  // private isAvaliableStatus(propose: Propose, status: string) {
  //   let availableStatuses = [];
    
  //   switch (status) {
  //     case 'U_PROCESSING':
  //       availableStatuses = ['WAIT', 'REQUEST', 'TO_DO', 'PROCESSING'];
  //       break;
  //     case 'U_DONE':
  //       availableStatuses = ['CANCEL', 'DONE'];
  //       break;
  //     case 'C_REQUEST':
  //       availableStatuses = ['REQUEST'];
  //       break;
  //     case 'C_TODO':
  //       availableStatuses = ['TO_DO'];
  //       break;
  //     case 'C_PROCESSING':
  //       availableStatuses = ['PROCESSING'];
  //       break;
  //     case 'C_DONE':
  //       availableStatuses = ['DONE'];
  //       break;
  //   }
  //   return _.includes(availableStatuses, propose.status);
  // }
}



// WEBPACK FOOTER //
// ./src/services/propose.service.ts